import { MFLink } from '@medifind/shared-basic-components';
import styles from './LearnTiers.module.scss';

const LearnTiers = ({ inline, showTiers, toggleTiers }) => {
  if (inline) {
    return (
      <div className={styles['tiers__button__container']} id="expert-tiers-inline">
        <MFLink onClick={toggleTiers} className={styles['tiers__button__element']}>
          {showTiers ? 'Close' : 'Learn about our expert tiers'}
        </MFLink>
      </div>
    );
  } else {
    return (
      <MFLink onClick={toggleTiers} className={styles['tiers__container']} id="expert-tiers">
        <div className={styles['tiers__colorswatch']}>
          <div className={styles['tiers__colorswatch--red']}>&nbsp;</div>
          <div className={styles['tiers__colorswatch--purple']}>&nbsp;</div>
          <div className={styles['tiers__colorswatch--navy']}>&nbsp;</div>
          <div className={styles['tiers__colorswatch--blue']}>&nbsp;</div>
        </div>
        <div className={styles['tiers__text']}>
          <div className={styles['tiers__text--title']}>Learn about our expert tiers</div>
          <div className={styles['tiers__text__button']}>
            <span>{showTiers ? 'Close' : 'Learn More'}</span>
          </div>
        </div>
      </MFLink>
    );
  }
};

export { LearnTiers as default, LearnTiers };
